import LabResult from '../../model/labResult'
import mapUser from './userMapper'
import moment from 'moment';

const positiveIndicator = "POSITIVE";
const negativeIndicator = "NEGATIVE";
const pendingIndicator = "NORESULT";
const equivocalIndicator = "EQUIVOCAL";

export const POSITIVE = "positive";
export const NEGATIVE = "negative";
export const PENDING = "pending";
export const UNKNOWN = "unknown";
export const EQUIVOCAL = "equivocal";

export function mapUserResults(data){
    let results = [];
    let newResult = null;
    let noResultOverride = false;


    for(let i = 0; i < data.results.length; i++) {
        // Map coordinates
        let d = data.results[i];
        let res = mapResult(d.resultCode);
        // If result is noresult, use that one and ignore all others.
        if (res === PENDING) {
            noResultOverride = true;
            let override = new LabResult(d.resultType, res, d.result, null, null, null, null, null);
            results = [ override ];
            break;
        }
        let date = moment(d.collectionDate, moment.ISO_8601);
        newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, date, d.messageId, d.facilityNumber);
        results.push(newResult);
    }
    return results;
}

export function mapFakeLabResults(data){
    let results = [];
    let user = null;
    let newResult = null;

    let noResultOverride = false;

    let modifiedUser = data;
    user = mapUser(modifiedUser);
    for(let i = 0; i < data.results.length; i++) {
        // Map coordinates
        let d = data.results[i];
        let res = mapResult(d.resultCode);
        // If result is noresult, use that one and ignore all others.
        if (res === PENDING) {
            noResultOverride = true;
            let override = new LabResult(d.resultType, res, d.result, null, null, null, null, null);
            results = [ override ];
            break;
        }
        let date = moment(d.collectionDate, moment.ISO_8601);
        newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, date, d.messageId, d.facilityNumber);
        results.push(newResult);
    }

    // Sort results by date..
    let sortedResults = [];
    if (noResultOverride === false) {
        sortedResults = results.sort(function(a, b) {
            return b.date - a.date;
        });
    } else {
        sortedResults = results;
    }

    let dependents = [];
    let dependentResults = [];
    if(data.dependents !== undefined){
        for(let i = 0; i <data.dependents.length; i++){
            let modifiedDependent = data.dependents[i].patientResults;
            modifiedDependent.isDependent = true;
            modifiedDependent.id= data.dependents[i].id;
            let dependent = mapUser(modifiedDependent);
            dependents.push(dependent);
            let tempDepResults = (data.dependents[i].patientResults.results);
            let depResult = [];
            
            for(let j = 0; j < tempDepResults.length; j++) {
            //     // Map coordinates
                let d = tempDepResults[j];
                let res = mapResult(d.resultCode);
                // If result is noresult, use that one and ignore all others.
                if (res === PENDING) {
                    noResultOverride = true;
                    let override = new LabResult(d.resultType, res, d.result, null, null, null, null, null);
                    results = [ override ];
                    break;
                }
                let date = moment(d.collectionDate, moment.ISO_8601);
                newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, date, d.messageId, d.facilityNumber);
                depResult.push(newResult);
            }
            dependentResults.push(depResult);
        }
    }
    console.log(dependentResults);
    return { user, sortedResults, dependents, dependentResults};
}

export function mapFakeLabResultsWithDependants(data) {
    let results = [];
    let user = null;
    let newResult = null;

    let noResultOverride = false;

    let modifiedUser = data;
    user = mapUser(modifiedUser);
    for(let i = 0; i < data.results.length; i++) {
        // Map coordinates
        let d = data.results[i];
        let res = mapResult(d.resultCode);
        // If result is noresult, use that one and ignore all others.
        if (res === PENDING) {
            noResultOverride = true;
            let override = new LabResult(d.resultType, res, d.result, null, null, null);
            results = [ override ];
            break;
        }
        let date = moment(d.collectionDate, moment.ISO_8601);
        newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, date);
        results.push(newResult);
    }

    // Sort results by date..
    let sortedResults = [];
    if (noResultOverride === false) {
        sortedResults = results.sort(function(a, b) {
            return b.date - a.date;
        });
    } else {
        sortedResults = results;
    }

    let dependents = [];
    let dependentResults = [];
    if(data.dependents !== undefined){
        for(let i = 0; i <data.dependents.length; i++){
            let modifiedDependent = data.dependents[i].patientResults;
            modifiedDependent.isDependent = true;
            modifiedDependent.id= data.dependents[i].id;
            let dependent = mapUser(modifiedDependent);
            dependents.push(dependent);
            let tempDepResults = (data.dependents[i].patientResults.results);
            let depResult = [];
            
            for(let j = 0; j < tempDepResults.length; j++) {
            //     // Map coordinates
                let d = tempDepResults[j];
                let res = mapResult(d.resultCode);
                // If result is noresult, use that one and ignore all others.
                if (res === PENDING) {
                    noResultOverride = true;
                    let override = new LabResult(d.resultType, res, d.result, null, null, null);
                    results = [ override ];
                    depResult.push(override);
                    break;
                }
                let date = moment(d.collectionDate, moment.ISO_8601);
                newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, date);
                depResult.push(newResult);
            }
            dependentResults.push(depResult);
        }
    }
    console.log(dependentResults);
    return { user, sortedResults, dependents, dependentResults};

}

function mapResult(result) {
    let res = UNKNOWN;
    if (result === positiveIndicator) {
        res = POSITIVE;
    } else if (result === negativeIndicator) {
        res = NEGATIVE;
    } else if (result === pendingIndicator) {
        res = PENDING;
    } else if (result === equivocalIndicator) {
        res = EQUIVOCAL;
    }
    return res;
}
